import { action } from 'satcheljs';

export interface SET_SWEEP_DESTINATION_FOLDER_IDActionMessage {
    folderId: string;
}
const defaultExport: (folderId: string) => SET_SWEEP_DESTINATION_FOLDER_IDActionMessage = action(
    'SET_SWEEP_DESTINATION_FOLDER_ID',
    (folderId: string): SET_SWEEP_DESTINATION_FOLDER_IDActionMessage => ({
        folderId,
    })
);
export default defaultExport;
